import api from "@/services/api";
import {
  CatalogProductType,
  CreatePdvSaleResponse,
  InventoryMovementType,
  PdvSaleType,
  ProductCategoryType,
} from "@/types/pdv/Pdv";

class PdvApi {
  listCategories = async (params?: Record<string, unknown>) => {
    const res = await api().get("/pdv/categories", { params });
    return res.data as { data: ProductCategoryType[]; total: number };
  };

  createCategory = async (data: Partial<ProductCategoryType>) => {
    const res = await api().post("/pdv/categories", data);
    return res.data as ProductCategoryType;
  };

  updateCategory = async (id: string, data: Partial<ProductCategoryType>) => {
    const res = await api().put(`/pdv/categories/${id}`, data);
    return res.data as ProductCategoryType;
  };

  listProducts = async (params?: Record<string, unknown>) => {
    const res = await api().get("/pdv/products", { params });
    return res.data as { data: CatalogProductType[]; total: number };
  };

  getProduct = async (id: string) => {
    const res = await api().get(`/pdv/products/${id}`);
    return res.data as CatalogProductType;
  };

  listCatalog = async (params?: Record<string, unknown>) => {
    const res = await api().get("/pdv/products/catalog", { params });
    return res.data as { data: CatalogProductType[]; total: number };
  };

  createProduct = async (data: Partial<CatalogProductType>) => {
    const res = await api().post("/pdv/products", data);
    return res.data as CatalogProductType;
  };

  updateProduct = async (id: string, data: Partial<CatalogProductType>) => {
    const res = await api().put(`/pdv/products/${id}`, data);
    return res.data as CatalogProductType;
  };

  searchCustomers = async (query: string) => {
    const res = await api().get("/pdv/customers/search", { params: { query } });
    return res.data as Array<{ id: string; name: string; document: string; phone?: string }>;
  };

  createSale = async (data: Record<string, unknown>) => {
    const res = await api().post("/pdv/sales", data);
    return res.data as CreatePdvSaleResponse;
  };

  listSales = async (params?: Record<string, unknown>) => {
    const res = await api().get("/pdv/sales", { params });
    return res.data as { data: PdvSaleType[]; total: number };
  };

  getSale = async (id: string) => {
    const res = await api().get(`/pdv/sales/${id}`);
    return res.data as PdvSaleType;
  };

  cancelSale = async (id: string, reason: string) => {
    const res = await api().post(`/pdv/sales/${id}/cancel`, { reason });
    return res.data;
  };

  confirmBrpoints = async (id: string) => {
    const res = await api().post(`/pdv/sales/${id}/confirm-brpoints`);
    return res.data;
  };

  getDashboard = async () => {
    const res = await api().get("/pdv/dashboard");
    return res.data;
  };

  createInventoryMovement = async (data: Record<string, unknown>) => {
    const res = await api().post("/pdv/inventory/movements", data);
    return res.data;
  };

  listInventoryMovements = async (params?: Record<string, unknown>) => {
    const res = await api().get("/pdv/inventory/movements", { params });
    return res.data as { data: InventoryMovementType[]; total: number };
  };
}

export const pdvApi = new PdvApi();
